import React from 'react';
import ReactDOM from 'react-dom/client';

import CONFIG from '@/config/config.ts';

import './i18n.ts';
import './index.css';
import { initErrorMonitoring } from '@/monitoring/sentry.util.ts';
// Loaded on demand so react-scan stays out of the production bundle unless the flag is on
if (import.meta.env.DEV || CONFIG.PERFORMANCE_SCAN === 'true') {
  const { scan } = await import('react-scan');
  if (import.meta.env.DEV) {
    scan({ enabled: true });
  }
  scan({ enabled: CONFIG.PERFORMANCE_SCAN === 'true' });
}
import App from './App';

initErrorMonitoring();
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
